import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthPath } from '@/shared/constants/path';
import User from '@/shared/types/user';

type UseAuthGuardProps = {
  user: User | null;
  isLoading: boolean;
};

const useAuthGuard = ({ user, isLoading }: UseAuthGuardProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !user) {
      navigate(AuthPath.Login);
    }
  }, [user, isLoading, navigate]);
};

export default useAuthGuard;
